/* global initCookieConsent Cookies */

import 'vanilla-cookieconsent'
import '../../plugins/js-cookie'
import { addGoogleTagManager } from '../../main/cegep.analytics'

const cc = initCookieConsent()

cc.run({
  current_lang: 'fr',
  onAccept: () => addOrRemoveCookies(cc),
  onChange: () => refreshCookies(cc),
  languages: {
    en: {
      consent_modal: {
        title: 'Ce site web utilise des cookies',
        description: "Ce site utilise des cookies pour am\u00e9liorer votre exp\u00e9rience et optimiser le fonctionnement du site. Vous pouvez accepter ces cookies en cliquant sur ' Autoriser tous les cookies ', cliquer sur ' Param\u00e9trer les cookies ' pour g\u00e9rer vos pr\u00e9f\u00e9rences de cookies.",
        primary_btn: {
          text: 'Autoriser tous les cookies',
          role: 'accept_all' // 'accept_selected' or 'accept_all'
        },
        secondary_btn: {
          text: 'Param\u00e9trer les cookies',
          role: 'settings' // 'settings' or 'accept_necessary'
        }
      },
      settings_modal: {
        title: 'Param\u00e9trer les cookies',
        save_settings_btn: 'Sauvegarder param\u00e8tre',
        accept_all_btn: 'Tout accepter',
        close_btn_label: 'Fermer',
        blocks: [
          {
            title: 'Utilisation des cookies',
            description: ''
          }, {
            title: 'Cookies strictement n\u00e9cessaire',
            description: 'Ces cookies sont n\u00e9cessaires au bon fonctionnement du site.',
            toggle: {
              value: 'necessary_cookies',
              enabled: true,
              readonly: true
            }
          }, {
            title: 'Cookies fonctionnels',
            description: "Ces cookies nous permettent de d\u00e9terminer l'historique des pages visit\u00e9es",
            toggle: {
              value: 'historique_cookies',
              enabled: true,
              readonly: false
            }
          },
          {
            title: 'Google Analytics',
            description: "Ce cookie nous permet d'utiliser Google Analytics",
            toggle: {
              value: 'analytics_cookies',
              enabled: true,
              readonly: false
            }
          }
        ]
      }
    }
  }
})

function addOrRemoveCookies (cc) {
  if (cc.allowedCategory('historique_cookies')) {
    setHistoryCookie()
  } else {
    deleteHistoryCookie()
  }

  if (cc.allowedCategory('analytics_cookies')) {
    addGoogleTagManager(window.gtmTrackingCode)
  } else {
    deleteAnaltyicsCookies()
  }
}

function refreshCookies (cc) {
  if (cc.allowedCategory('historique_cookies')) {
    if (Cookies.get('history') === undefined) {
      setHistoryCookie()
    }
  } else {
    deleteHistoryCookie()
  }

  if (cc.allowedCategory('analytics_cookies')) {
    if (Cookies.get('_ga') === undefined) {
      addGoogleTagManager(window.gtmTrackingCode)
    }
  } else {
    deleteAnaltyicsCookies()
  }
}

function setHistoryCookie () {
  const nodeId = document.head.querySelector('meta[name=id]').content
  const historyVal = Cookies.get('history')
  const newHistory = historyVal === undefined ? nodeId : `${historyVal},${nodeId}`
  Cookies.set('history', newHistory, { sameSite: 'strict', secure: true })
}

function deleteHistoryCookie () {
  Cookies.remove('history', { path: '/' })
}

function deleteAnaltyicsCookies () {
  const analyticsCookies = ['_fbp', '_ga', '_gid']
  analyticsCookies.forEach(c => Cookies.remove(c, { path: '/' }))
}
